import React from 'react'
import PropTypes from 'prop-types'

const WarningIcon = (props) => {
  const { color = '#F59E0B', classes = '' } = props
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M1.50493 16.9609H17.5023C18.6204 16.9609 19.3413 15.8627 18.8354 14.9344L10.8367 1.73151C10.2852 0.70408 8.70677 0.70408 8.15529 1.73151L0.156617 14.9344C-0.334072 15.8607 0.386764 16.9609 1.50493 16.9609ZM10.7585 13.8908C10.7585 14.5764 10.2223 15.1043 9.45583 15.1043C8.6894 15.1043 8.15311 14.5764 8.15311 13.8908V13.8625C8.15311 13.1768 8.6894 12.649 9.45583 12.649C10.2223 12.649 10.7585 13.1768 10.7585 13.8625V13.8908ZM8.75236 4.97156H10.2548C10.6674 4.97156 10.9127 5.2992 10.8671 5.71381L10.2071 11.0795C10.1615 11.4658 9.88573 11.7065 9.50142 11.7065C9.1193 11.7065 8.84138 11.4638 8.79579 11.0795L8.13575 5.71381C8.09449 5.2992 8.33984 4.97156 8.75236 4.97156Z"
        fill={color}
      />
    </svg>
  )
}

WarningIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(WarningIcon)
